export default __webpack_public_path__ + "static/media/smallBannerBg.1f839ea2.png";